
	import { Component, Vue, Prop } from 'vue-property-decorator';
	import cssBundlerModule from '@/HostApp/services/CSSBundler/CSSBundlerModule';
	import designTokensModule from '@/HostApp/services/DesignTokens/DesignTokensModule';

	@Component({
		components: {}
	})
	export default class VueIframe extends Vue {
		@Prop({ required: true })
		protected src!: string;

		@Prop({ default: false })
		protected injectCssVars!: boolean;

		protected loaded: boolean = false;
		protected vueIframe: HTMLIFrameElement | null = null;

		protected async onIframeLoad(): Promise<void> {
			this.vueIframe = this.$refs.vueIframe as HTMLIFrameElement;
			// @ts-ignore
			this.vueIframe.addEventListener('message', (event: [string, data]) => {
				const [message, data] = event;
				this.$emit(message, data);
			});

			if (this.injectCssVars) {
				await cssBundlerModule.applyCSSBundlesToIframe(this.vueIframe, [], designTokensModule.cssVariables);
			}

			this.loaded = true;

			this.$emit('iframe-loaded', this.loaded, this.vueIframe);
		}
	}
